import {DownloadableFile} from "@flowmaps-com/flowmaps-typescriptmodels";
import {Observable, Subscriber} from "rxjs";

export const LOCATION_IMAGE_MAX_BYTES = 2 * 1024 * 1024;
export const LOCATION_IMAGE_CONTENT_TYPES = ["image/jpeg", "image/png", "image/webp"];

export function downloadableFileToDataUrl(file: DownloadableFile): string {
    if (!file?.base64Data || !file?.mediaType) {
        return null;
    }
    return `data:${file.mediaType};base64,${file.base64Data}`;
}

export function readFileAsBase64(file: File): Observable<string> {
    const reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    return new Observable((s: Subscriber<string>) => {
        reader.onload = () => {
            const result = String(reader.result || "");
            s.next(result.substring(result.indexOf(",") + 1));
            s.complete();
        };
        reader.onerror = () => s.error(reader.error);
    });
}
